export default "__VITE_ASSET__BK80UYwr__"